import * as actionTypes from '@store/actions/actionTypes';
import createReducer from '@utils/createReducer';

import { EIntegrationTypes } from '../../utils/integrationTypes';

const initialState = {
  list: Object.values(EIntegrationTypes),
  connected: [],
  error: null,
  requesting: false,

  verifying: false,
  verificationError: null,
  verificationResult: null,

  igAccountId: null,
  igVerifyResult: null,
  igVerifyFinished: false,
  igVerifyError: null,
  igSendCodeError: null,
  igSendCodeResult: null,
  igCheckCodeResult: null,

  emailCampaignId: 0,
  emailCampaignRequesting: false,
  emailCampaignError: null,
  integrationsConnectedAllStore: {},
  posts: [],
};

const integrations = createReducer(initialState, {
  // integrations list
  [actionTypes.INTEGRATIONS_GET_CONNECTED_REQUEST](state) {
    return { ...state, requesting: true, error: null };
  },
  [actionTypes.SET_STORE_POSTS](state, { payload }) {
    return { ...state, posts: payload };
  },
  [actionTypes.INTEGRATIONS_GET_CONNECTED_ERROR](state, { payload }) {
    return { ...state, error: payload, requesting: false };
  },
  [actionTypes.INTEGRATIONS_GET_CONNECTED_STORE](state, { payload }) {
    console.log('INTEGRATIONS_GET_CONNECTED_STORE', payload);

    return {
      ...state,
      connected: [...payload],
      requesting: false,
      error: null,
    };
  },
  [actionTypes.INTEGRATIONS_GET_CONNECTED_ALL_STORE](state, { payload }) {
    return {
      ...state,
      integrationsConnectedAllStore: payload,
      requesting: false,
      error: null,
    };
  },
  // integration disconnect
  [actionTypes.DISCONNECT_INTEGRATION_REQUEST](state) {
    return { ...state, requesting: true, error: null };
  },
  [actionTypes.DISCONNECT_INTEGRATION_ERROR](state, { payload }) {
    return { ...state, error: payload, requesting: false };
  },
  [actionTypes.DISCONNECT_INTEGRATION_STORE](state, { payload }) {
    return {
      ...state,
      connected: [...state.connected.filter((x) => x !== payload)],
      requesting: false,
      error: null,
    };
  },
  // add integration
  [actionTypes.INTEGRATIONS_CONNECT_REQUEST](state) {
    return { ...state, requesting: true };
  },
  [actionTypes.INTEGRATIONS_CONNECT_SUCCEED](state, { payload }) {
    return {
      ...state,
      connected: [...state.connected, payload],
      error: null,
      requesting: false,
    };
  },
  [actionTypes.INTEGRATIONS_CONNECT_FAILED](state, payload) {
    return { ...state, error: payload, requesting: false };
  },
  // integration verify
  [actionTypes.VERIFY_INTEGRATION_REQUEST](state) {
    return { ...state, verifying: true, verificationError: null };
  },
  [actionTypes.VERIFY_INTEGRATION_ERROR](state, { payload }) {
    return { ...state, verifying: false, verificationError: payload };
  },
  [actionTypes.VERIFY_INTEGRATION_SUCCESS](state, { payload }) {
    return { ...state, verifying: false, verificationError: null, verificationResult: payload };
  },
  // instagram account id
  [actionTypes.INSTAGRAM_STORE_ACCOUNT_ID](state, { payload }) {
    return { ...state, igAccountId: payload };
  },
  // instagram add account
  [actionTypes.INSTAGRAM_ADD_ACCOUNT_REQUEST](state) {
    return { ...state, verifying: true, igVerifyError: null };
  },
  [actionTypes.INSTAGRAM_ADD_ACCOUNT_ERROR](state, { payload }) {
    return { ...state, verifying: false, igVerifyError: payload };
  },
  [actionTypes.INSTAGRAM_ADD_ACCOUNT_SUCCESS](state, { payload }) {
    return { ...state, verifying: false, igVerifyError: null, igVerifyResult: payload };
  },
  // instagram verify account
  [actionTypes.INSTAGRAM_VERIFY_ACCOUNT_REQUEST](state) {
    return { ...state, verifying: true, igSendCodeResult: null, igSendCodeError: null };
  },
  [actionTypes.INSTAGRAM_VERIFY_ACCOUNT_ERROR](state, { payload }) {
    return { ...state, verifying: false, igSendCodeResult: null, igSendCodeError: payload };
  },
  [actionTypes.INSTAGRAM_VERIFY_ACCOUNT_SUCCESS](state, { payload }) {
    return {
      ...state,
      igVerifyResult: { ...state.igVerifyResult, status: Number.MAX_SAFE_INTEGER },
      verifying: false,
      igSendCodeError: null,
      igSendCodeResult: payload,
    };
  },
  // instagram check code
  [actionTypes.INSTAGRAM_CHECK_CODE_REQUEST](state) {
    return { ...state, verifying: true, igVerifyFinished: false, igCheckCodeResult: null };
  },
  [actionTypes.INSTAGRAM_CHECK_CODE_ERROR](state, { payload }) {
    return { ...state, verifying: false, igCheckCodeResult: payload };
  },
  [actionTypes.INSTAGRAM_CHECK_CODE_SUCCESS](state) {
    const { list, connected } = state;

    return {
      ...initialState,
      list,
      connected,
      igVerifyFinished: true,
    };
  },
  // convert email
  [actionTypes.CAMPAIGNS_CONVERT_EMAIL_REQUEST](state) {
    return { ...state, emailCampaignError: null, emailCampaignId: 0, emailCampaignRequesting: true };
  },
  [actionTypes.CAMPAIGNS_CONVERT_EMAIL_ERROR](state, { payload }) {
    return { ...state, emailCampaignError: payload, emailCampaignId: 0, emailCampaignRequesting: false };
  },
  [actionTypes.CAMPAIGNS_CONVERT_EMAIL_STORE](state, { payload }) {
    return { ...state, emailCampaignError: null, emailCampaignId: payload, emailCampaignRequesting: false };
  },
  // reset account
  [actionTypes.INSTAGRAM_ACCOUNT_RESET](state) {
    const { list, connected } = state;

    return { ...initialState, list, connected };
  },
});

export default integrations;

export const getList = (state) => state.integrations.list;
export const getConnected = (state) => state.integrations.connected;
export const getIsRequesting = (state) => state.integrations.requesting;
export const getError = (state) => state.integrations.error;

export const getIsVerifying = (state) => state.integrations.verifying;
export const getVerificationError = (state) => state.integrations.verificationError;
export const getVerificationResult = (state) => state.integrations.verificationResult;

export const getIgVerificationError = (state) => state.integrations.igVerifyError;
export const getIgVerificationResult = (state) => state.integrations.igVerifyResult;
export const getIgIsVerificationFinish = (state) => state.integrations.igVerifyFinished;
export const getIgSendCodeError = (state) => state.integrations.igSendCodeError;
export const getIgSendCodeResult = (state) => state.integrations.igSendCodeResult;
export const getIgCheckCodeResult = (state) => state.integrations.igCheckCodeResult;
export const getIgAccountId = (state) => state.integrations.igAccountId;

export const getEmailCampaignId = (state) => state.integrations.emailCampaignId;
export const getEmailCampaignError = (state) => state.integrations.emailCampaignError;
export const getEmailCampaignRequesting = (state) => state.integrations.emailCampaignRequesting;
export const getIntegrationsConnectedAllStore = (state) => state.integrations.integrationsConnectedAllStore;
export const getPosts = (state) => state.integrations.posts;
